function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={(styles["feather"] || "feather") + " " + (styles["feather-plus"] || "feather-plus")} viewBox="0 0 24 24" {...props}><path d="M12 5v14m-7-7h14" /></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/plus.icon.svg